import { queryOptions, useSuspenseQuery } from '@tanstack/react-query'
import {
    GrpcClientsContextValue,
    useGrpcClients,
} from '@/contexts/GrpcClientContext'
import { DeletedItemSelection } from '@/generated/Enumerations/DeletedItemSelection_pb'
import { BusinessLocationFiltersDto } from '@/generated/Messages/Filters_pb'
import { assertNotNullish } from '@/helper/assertNotNullish'
import {
    businessesLocationsQueryKeyPrefix,
    listQueryKeyPrefix,
} from '@/helper/queryKeyPrefixes'
import { OmitDeepMessageFields } from '@/types/OmitDeepMessageFields'

export const businessLocationsListQueryKeyPrefix = [
    businessesLocationsQueryKeyPrefix,
    listQueryKeyPrefix,
] as const

export const businessLocationsQueryOptions = (
    clients: Partial<GrpcClientsContextValue> | null,
    filter: Partial<OmitDeepMessageFields<BusinessLocationFiltersDto>> = {}
) =>
    // eslint-disable-next-line @tanstack/query/exhaustive-deps
    queryOptions({
        queryKey: [...businessLocationsListQueryKeyPrefix, filter],
        queryFn: async ({ signal }) => {
            assertNotNullish(clients?.businessLocation)

            return await clients.businessLocation.getBusinessLocations(
                {
                    deletedItemSelection:
                        filter.deletedItemSelection ??
                        DeletedItemSelection.BOTH,
                    ids: filter.ids ?? [],
                    sorting: filter.sorting ?? [],
                    pagination: filter.pagination,
                    searching: filter.searching ?? [],
                    searchOperator: filter.searchOperator,
                    businessIds: filter.businessIds ?? [],
                },
                { signal }
            )
        },
    })

export const useBusinessLocations = (
    filter: Partial<OmitDeepMessageFields<BusinessLocationFiltersDto>> = {}
) => {
    const clients = useGrpcClients()

    return useSuspenseQuery(businessLocationsQueryOptions(clients, filter))
}
